'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSettings = function IoIosSettings(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 8.1c-0.7 0-1.2 0.6-1.2 1.3s0.5 1.2 1.2 1.2 1.3-0.5 1.3-1.2-0.6-1.3-1.3-1.3z m0-1.2c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m0 22.5c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.3 1.2 1.3 1.3-0.6 1.3-1.3-0.6-1.2-1.3-1.2z m0-1.3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m-15-9.3c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.3 1.2 1.3 1.3-0.6 1.3-1.3-0.6-1.2-1.3-1.2z m0-1.3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5z m3.7 1.9h21.3v1.2h-21.3c0-0.2 0.1-0.4 0.1-0.6s-0.1-0.4-0.1-0.6z m-7.4 0.6c0 0.2 0 0.4 0 0.6h-6.3v-1.2h6.3c0 0.2 0 0.4 0 0.6z m22.4 10h6.3v1.3h-6.3c0-0.3 0.1-0.4 0.1-0.7s-0.1-0.4-0.1-0.6z m-7.4 0.6c0 0.3 0 0.4 0 0.7h-21.3v-1.3h21.3c0 0.2 0 0.4 0 0.6z m7.4-21.8h6.3v1.2h-6.3c0-0.2 0.1-0.4 0.1-0.6s-0.1-0.4-0.1-0.6z m-7.4 0c0 0.2 0 0.3 0 0.6s0 0.4 0 0.6h-21.3v-1.2h21.3z' })
        )
    );
};

exports.default = IoIosSettings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-settings.js
// module id = 2308
// module chunks = 0